__turbopack_context__.v({
  "container": "_iqopa_container",
  "pill": "_iqopa_pill",
});
